import { Button, ButtonProps, styled } from '@mui/material'

const RcmPrimaryButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.colors?.lightBlue,
  minWidth: '100px',
  borderRadius: 0,
  '&:hover': {
    backgroundColor: theme.palette.colors?.buttonHover
  },
  '&:active': {
    backgroundColor: theme.palette.colors?.blue1
  },
  '&:disabled': {
    backgroundColor: theme.palette.colors?.darkStroke,
    color: theme.palette.common.white
  }
}))

export default RcmPrimaryButton
